/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  // MutableRefObject,
  useEffect,
  // useRef,
} from 'react';

import './animation011.less';
// import { usePlayFlag } from './../../components/topicScroll';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

interface IAnimation011Item {
  icon: string;
  color: string;
  text: string;
}

interface IAnimation011Props {
  items: IAnimation011Item[];
  onCompleted: () => void;
  className?: string;
}

const Animation011: FunctionComponent<IAnimation011Props> = ({
  items,
  className,
  onCompleted,
}) => {
  // const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  // const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation011 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (isVisible) {
      startPlay();
    }
  }, [isVisible]);
  return (
    <div ref={targetRef} className={`animation011 component ${className}`}>
      <div className="animation011-content">
        {items.map((itm: IAnimation011Item, idx: number) => (
          <div
            key={idx}
            className={`animation011-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{ paddingLeft: idx * 50 }}
          >
            <div
              className="animation011-indicate-number"
              style={{ backgroundColor: itm.color }}
            >
              <div
                className="animation011-icon"
                style={{ borderColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="number">0{idx + 1} </div>
            </div>
            <div
              className="animation011-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation011;
